import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../shared/config/app-config';
import { UserService } from '../../shared';

@Component({
  selector: 'app-emailunsubscribe',
  templateUrl: './emailunsubscribe.component.html',
  styleUrls: ['./emailunsubscribe.component.css']
})
export class EmailunsubscribeComponent implements OnInit {

  public apiurl: any = environment.api_url;
  public params: any;
  public url: any;
  item: any;

  constructor(
    private activeroute: ActivatedRoute,
    private routers: Router,
    private userService: UserService,
    private modalService: BsModalService,
    private dialog: MatDialog,
    private httpClient: HttpClient,
    private toast: ToastrService,
    private nav: Router
  ) {
    this.activeroute.params.subscribe(params => {
      this.params = params;
    });


  }

  ngOnInit() {
    this.userService.getUnsubscribe(this.params.id)
      .subscribe(
        data => {
          ////console.log(data) 
          this.url = data
        })
  }




  confirmBtn: any;
  sendConfirm(id) {
    this.userService.postUnsubscribe(id)
      .subscribe(
        data => {
          this.confirmBtn = data;

          if (data.status == "Success") {
            this.toast.success(this.userService.translateText('patient_portal.display_messages.unsubscribed.success'))
            this.routers.navigate([`/login`])
          } else {
            this.toast.error(this.userService.translateText('patient_portal.display_messages.unsubscribed.error'))
            this.routers.navigate([`/login`])
          }
        }
      );
  }
}
